<template>
  <div>
    <div
      style="margin-bottom: 10px; border-bottom: 1px solid #ccc; padding: 10px; cursor: pointer"
      @click="$router.push(`/regalos/campaign/${campaign.id}/idea/${idea.id}`)"
    >
      <div style="display: flex; justify-content: left; align-items: center; gap: 10px">
        <div style="margin-right: 4px">
          <ImagesStacked :images="images" :size="65" :max-visible="2" />
        </div>

        <!-- title and details-->
        <div style="width: 100%">
          <div style="font-size: 110%; font-weight: bold">
            {{ idea.title || 'Sin título' }}
          </div>
          <!-- details -->
          <div>
            <div v-if="idea.options.length > 0">
              <!-- idea completed -->
              <div v-if="idea.completed">
                <!-- split is OFF (cleaner)-->
                <div v-if="!campaign.split_spend">
                  {{ spentIdea }}€
                  <span v-if="purchasedProducts.length > 1">
                    <span v-if="false"> ({{ purchasedProducts.length }} productos) </span>
                    <span
                      >({{
                        purchasedProducts
                          .map((o) => o.price)
                          .sort((a, b) => b - a)
                          .join('€ + ')
                      }}€)</span
                    >
                  </span>
                </div>
                <!-- when split is ON (payer detail)-->
                <div v-if="campaign.split_spend">
                  <div v-if="true">
                    <div v-for="(value, person) in spentByUser" :key="person">
                      <div>{{ value }}€ ({{ person }})</div>
                    </div>
                  </div>
                  <div v-if="false">
                    <v-chip label small class="mr-1" v-for="(value, person) in spentByUser" :key="person">
                      {{ person }}
                    </v-chip>
                  </div>
                </div>
              </div>

              <!-- idea not completed -->
              <div v-else>
                <!-- if more than one option, show number of options -->
                <div v-if="activeOptions.length > 1">Opciones: {{ activeOptions.length }}</div>
                <!-- if purchased, show number of purchased -->
                <div v-if="activeOptions.filter((o) => o.purchased).length">
                  Comprados: {{ activeOptions.filter((o) => o.purchased).length }}
                </div>
                <!-- price -->
                <div>
                  <!-- if one option, show price -->
                  <div v-if="activeOptions.length == 1">
                    Precio:
                    <span v-if="activeOptions[0].price && activeOptions[0].price > 0">
                      {{ activeOptions[0].price + '€' }}
                    </span>
                    <span v-else>???</span>
                  </div>
                  <div v-if="activeOptions.length > 1">
                    Precios:
                    {{
                      activeOptions
                        .map((o) => (o.price ? o.price : 0))
                        .sort((a, b) => a - b)
                        .map((p) => (p > 0 ? p + '€' : '???'))
                        .join(' | ')
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <v-btn icon x-large><v-icon>mdi-chevron-right</v-icon></v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nickname } from './regalos-data'
import ImagesStacked from './ImagesStacked.vue'
export default {
  components: {
    ImagesStacked,
  },
  props: {
    campaign: {
      type: Object,
      default() {
        return {}
      },
    },
    campaign_id: {
      type: String,
      default: '',
    },
    idea: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    images() {
      const o = [...this.idea.options]

      //put first the ones that are not discarded
      o.sort((a, b) => {
        if (a.discarded && !b.discarded) return 1
        if (!a.discarded && b.discarded) return -1
        //returned
        if (a.returned && !b.returned) return 1
        if (!a.returned && b.returned) return -1
        return 0
      })
      const x = o.map((b) => b.image_url)

      return x
    },
    activeOptions() {
      return this.idea.options.filter((o) => o.discarded !== true && o.returned !== true)
    },
    purchasedProducts() {
      return this.idea.options.filter((o) => o.purchased && !o.returned)
    },
    spentByUser() {
      const x = { Total: 0 }
      for (let j = 0; j < this.idea.options.length; j++) {
        const option = this.idea.options[j]
        if (option.purchased) {
          //total
          x.Total += +option.price
          x.Total = +x.Total.toFixed(2)
          //by user
          const payer = nickname(option.paidBy)
          if (!x[payer]) x[payer] = 0
          x[payer] += +option.price
          x[payer] = +x[payer].toFixed(2)
        }
      }
      delete x.Total
      return x
    },

    spentIdea() {
      let total = 0
      for (let j = 0; j < this.purchasedProducts.length; j++) {
        const option = this.purchasedProducts[j]
        total += +option.price
      }
      return total
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped></style>
